<template>
  <!-- 시험 공개 모달 -->
  <el-dialog :width="localWidth" :visible.sync="dialogVisible" :before-close="handleClose" append-to-body>
    <div>
      <h5>{{localTitle}}성적표 알림톡을 발송하시겠습니까?</h5>
    </div>
    <div>
      <el-radio-group v-model="sendType" class="stone-radio-btton exam-send-grade">
        <el-radio-button label="S">학생</el-radio-button>
        <el-radio-button label="P">학부모</el-radio-button>
        <el-radio-button label="A">학생 + 학부모</el-radio-button>
      </el-radio-group>
    </div>
    <div style="margin-top: 20px; text-align: right;">
      <el-button @click="handleClose" class="btn-default">취소</el-button>
      <el-button type="primary" @click="confirmClickHandler">확인</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'SendGradeNotification',
  props: {
    width: {
      type: String,
      required: false,
      default: '480px'
    },
    title: {
      type: String,
      required: false,
      default: ''
    }
  },
  data () {
    return {
      dialogVisible: false,
      localTitle: this.title,
      sendType: 'S',
      localWidth: this.width
    }
  },
  methods: {
    handleClose () {
      this.dialogVisible = false
    },
    confirmClickHandler () {
      this.dialogVisible = false
      this.$emit('confirm-click', this.sendType)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/components/sendGradeNotification.vue